<template>
  <main-template>
    <v-row align="center" class="mb-1">
      <v-col>
        <h1>
          <v-btn color="primary" x-small text @click="$router.go(-1)">
            <v-icon left>fa fa-angle-left</v-icon>
          </v-btn>
          Gerenciar Feriados
        </h1>
      </v-col>
      <v-col cols="auto">
        <v-select
          v-model="anoSelecionado"
          :items="anos"
          label="Ano"
          outlined
          dense
          hide-details
          style="width: 110px"
        />
      </v-col>
    </v-row>

    <v-row class="mb-3">
      <v-col cols="auto">
        <v-btn color="primary" @click="abrirFormulario(null)">
          <v-icon left>mdi-plus</v-icon>
          Cadastrar Feriado
        </v-btn>
      </v-col>
      <v-col cols="auto">
        <v-btn color="secondary" outlined @click="abrirImportacao">
          <v-icon left>mdi-calendar-import</v-icon>
          Importar do Calendário Letivo
        </v-btn>
      </v-col>
    </v-row>

    <v-card outlined>
      <v-card-text class="pa-0">
        <v-data-table
          :headers="headers"
          :items="feriadosFiltrados"
          :loading="carregando"
          no-data-text="Nenhum feriado cadastrado para este ano"
          loading-text="Carregando..."
          sort-by="data"
        >
          <template #[`item.data`]="{ item }">
            {{ formatarData(item.data) }}
          </template>
          <template #[`item.tipo`]="{ item }">
            <v-chip small :color="corTipo(item.tipo)" dark>
              {{ labelTipo(item.tipo) }}
            </v-chip>
          </template>
          <template #[`item.uf`]="{ item }">
            {{ item.uf || "—" }}
          </template>
          <template #[`item.acoes`]="{ item }">
            <v-tooltip bottom>
              <template #activator="{ on }">
                <v-btn icon small color="primary" v-on="on" @click="visualizar(item)">
                  <v-icon small>mdi-eye</v-icon>
                </v-btn>
              </template>
              <span>Visualizar</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template #activator="{ on }">
                <v-btn icon small color="warning" v-on="on" @click="abrirFormulario(item)">
                  <v-icon small>mdi-pencil</v-icon>
                </v-btn>
              </template>
              <span>Editar</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template #activator="{ on }">
                <v-btn icon small color="error" v-on="on" @click="confirmarExclusao(item)">
                  <v-icon small>mdi-delete</v-icon>
                </v-btn>
              </template>
              <span>Excluir</span>
            </v-tooltip>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>

    <v-dialog v-model="dialogVisualizar" max-width="500">
      <v-card v-if="itemVisualizado">
        <v-card-title class="d-flex align-center justify-space-between">
          <span>Detalhes do Feriado</span>
          <v-chip small :color="corTipo(itemVisualizado.tipo)" dark>
            {{ labelTipo(itemVisualizado.tipo) }}
          </v-chip>
        </v-card-title>
        <v-divider />
        <v-card-text class="pt-4">
          <v-row dense>
            <v-col cols="12">
              <div class="caption grey--text text--darken-1">Nome</div>
              <div class="body-1 font-weight-medium">{{ itemVisualizado.nome }}</div>
            </v-col>
            <v-col cols="6">
              <div class="caption grey--text text--darken-1 mt-2">Data</div>
              <div class="body-2">{{ formatarData(itemVisualizado.data) }}</div>
            </v-col>
            <v-col v-if="itemVisualizado.uf" cols="6">
              <div class="caption grey--text text--darken-1 mt-2">UF</div>
              <div class="body-2">{{ itemVisualizado.uf }}</div>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="dialogVisualizar = false">Fechar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog" max-width="500" persistent>
      <v-card>
        <v-card-title>{{ modoEdicao ? "Editar Feriado" : "Cadastrar Feriado" }}</v-card-title>
        <v-card-text>
          <v-form ref="formRef">
            <v-text-field
              v-model="form.nome"
              label="Nome do Feriado *"
              outlined
              dense
              counter="200"
              :rules="[
                (v) => !!v || 'Nome obrigatório',
                (v) => !v || v.length <= 200 || 'Máximo 200 caracteres',
                validarTexto,
              ]"
            />

            <v-menu
              v-model="menuData"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template #activator="{ on, attrs }">
                <v-text-field
                  :value="form.data ? formatarData(form.data) : ''"
                  label="Data *"
                  outlined
                  dense
                  readonly
                  prepend-inner-icon="mdi-calendar"
                  v-bind="attrs"
                  v-on="on"
                  :rules="[() => !!form.data || 'Data obrigatória']"
                />
              </template>
              <v-date-picker v-model="form.data" locale="pt-BR" @input="menuData = false" />
            </v-menu>

            <v-select
              v-model="form.tipo"
              :items="tiposOptions"
              label="Tipo *"
              outlined
              dense
              :rules="[(v) => !!v || 'Tipo obrigatório']"
              @change="onTipoChange"
            />

            <v-select
              v-if="form.tipo === 'estadual' || form.tipo === 'municipal'"
              v-model="form.uf"
              :items="ufs"
              :label="form.tipo === 'estadual' ? 'UF *' : 'UF (Estado) *'"
              outlined
              dense
              :rules="[(v) => !!v || 'UF obrigatória']"
            />
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text :disabled="salvando" @click="fecharFormulario">Cancelar</v-btn>
          <v-btn color="primary" :loading="salvando" @click="salvar">Salvar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogExclusao" max-width="400">
      <v-card>
        <v-card-title>Confirmar Exclusão</v-card-title>
        <v-card-text>
          Deseja excluir o feriado
          <strong>{{ feriadoParaExcluir && feriadoParaExcluir.nome }}</strong
          >?
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text :disabled="excluindo" @click="dialogExclusao = false">Cancelar</v-btn>
          <v-btn color="error" :loading="excluindo" @click="excluir">Excluir</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogImportacao" max-width="760" persistent>
      <v-card>
        <v-card-title>Importar do Calendário Letivo</v-card-title>
        <v-card-text>
          <div v-if="carregandoPreview" class="text-center py-6">
            <v-progress-circular indeterminate color="primary" />
            <div class="mt-2 grey--text">Buscando eventos do Calendário Letivo...</div>
          </div>

          <div v-else-if="previewItens.length === 0" class="text-center py-6 grey--text">
            Nenhum evento encontrado no Calendário Letivo do ano letivo atual.
          </div>

          <template v-else>
            <v-row dense class="mb-3">
              <v-col cols="12" sm="5">
                <v-select
                  v-model="importacaoTipo"
                  :items="tiposOptions"
                  label="Tipo dos feriados importados *"
                  outlined
                  dense
                  hide-details
                />
              </v-col>
              <v-col v-if="importacaoTipo === 'estadual'" cols="12" sm="3">
                <v-select
                  v-model="importacaoUf"
                  :items="ufs"
                  label="UF *"
                  outlined
                  dense
                  hide-details
                />
              </v-col>
            </v-row>

            <v-simple-table dense>
              <thead>
                <tr>
                  <th style="width: 48px">
                    <v-tooltip bottom>
                      <template #activator="{ on }">
                        <v-btn icon x-small v-on="on" @click="selecionarTodosItens">
                          <v-icon x-small>
                            {{
                              todosSelecionados
                                ? "mdi-check-all"
                                : "mdi-plus-circle-multiple-outline"
                            }}
                          </v-icon>
                        </v-btn>
                      </template>
                      <span>{{ todosSelecionados ? "Desmarcar todos" : "Selecionar todos" }}</span>
                    </v-tooltip>
                  </th>
                  <th>Nome (editável)</th>
                  <th style="width: 110px">Data</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(item, idx) in previewItens"
                  :key="idx"
                  :class="item.selecionado ? 'green lighten-5' : ''"
                >
                  <td>
                    <v-btn
                      icon
                      x-small
                      :color="item.selecionado ? 'success' : 'grey'"
                      @click="toggleItemPreview(idx)"
                    >
                      <v-icon x-small>
                        {{ item.selecionado ? "mdi-check-circle" : "mdi-plus-circle-outline" }}
                      </v-icon>
                    </v-btn>
                  </td>
                  <td>
                    <v-text-field
                      v-model="item.nome"
                      dense
                      hide-details
                      single-line
                      :disabled="!item.selecionado"
                    />
                  </td>
                  <td class="body-2">{{ formatarData(item.data) }}</td>
                </tr>
              </tbody>
            </v-simple-table>

            <div class="mt-3 caption grey--text">
              <span v-if="totalSelecionados === 0">
                Clique em <v-icon x-small>mdi-plus-circle-outline</v-icon> para selecionar os
                feriados a importar.
              </span>
              <span v-else>
                <strong>{{ totalSelecionados }}</strong> de {{ previewItens.length }} selecionado(s)
                para importar.
              </span>
            </div>
          </template>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text :disabled="importando" @click="fecharImportacao">Cancelar</v-btn>
          <v-btn
            v-if="!carregandoPreview && previewItens.length > 0"
            color="secondary"
            :loading="importando"
            :disabled="totalSelecionados === 0"
            @click="confirmarImportacao"
          >
            Importar {{ totalSelecionados > 0 ? `(${totalSelecionados})` : "" }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </main-template>
</template>

<script>
export default {
  name: "FeriadosPage",
  data() {
    return {
      feriados: [],
      carregando: false,
      anoSelecionado: new Date().getFullYear(),
      dialog: false,
      salvando: false,
      modoEdicao: false,
      itemEditando: null,
      menuData: false,
      dialogVisualizar: false,
      itemVisualizado: null,
      dialogExclusao: false,
      excluindo: false,
      feriadoParaExcluir: null,
      form: { nome: "", data: "", tipo: "nacional", uf: "" },
      tiposOptions: [
        { text: "Nacional", value: "nacional" },
        { text: "Estadual", value: "estadual" },
        { text: "Municipal", value: "municipal" },
      ],
      ufs: [
        "AC",
        "AL",
        "AP",
        "AM",
        "BA",
        "CE",
        "DF",
        "ES",
        "GO",
        "MA",
        "MT",
        "MS",
        "MG",
        "PA",
        "PB",
        "PR",
        "PE",
        "PI",
        "RJ",
        "RN",
        "RS",
        "RO",
        "RR",
        "SC",
        "SP",
        "SE",
        "TO",
      ],
      headers: [
        { text: "Nome", value: "nome" },
        { text: "Data", value: "data" },
        { text: "Tipo", value: "tipo", align: "center" },
        { text: "UF", value: "uf", align: "center" },
        { text: "Ações", value: "acoes", sortable: false, align: "center", width: "120" },
      ],
      dialogImportacao: false,
      carregandoPreview: false,
      previewItens: [],
      importacaoTipo: "municipal",
      importacaoUf: "",
      importando: false,
    };
  },
  computed: {
    anos() {
      const anoAtual = new Date().getFullYear();
      const anosNaLista = this.feriados
        .map((f) => parseInt(String(f.data).split("T")[0].split("-")[0], 10))
        .filter(Boolean);
      const conjunto = new Set([anoAtual, ...anosNaLista]);
      return Array.from(conjunto).sort((a, b) => b - a);
    },
    feriadosFiltrados() {
      return this.feriados.filter((f) => {
        const ano = parseInt(String(f.data).split("T")[0].split("-")[0], 10);
        return ano === this.anoSelecionado;
      });
    },
    totalSelecionados() {
      return this.previewItens.filter((i) => i.selecionado).length;
    },
    todosSelecionados() {
      return this.previewItens.length > 0 && this.previewItens.every((i) => i.selecionado);
    },
  },
  mounted() {
    this.carregar();
  },
  methods: {
    async carregar() {
      try {
        this.carregando = true;
        this.feriados = await this.$services.colaboradorPontosService.listarFeriados();
      } catch (error) {
        this.$handleError(error);
      } finally {
        this.carregando = false;
      }
    },
    visualizar(item) {
      this.itemVisualizado = item;
      this.dialogVisualizar = true;
    },
    abrirFormulario(item) {
      this.modoEdicao = !!item;
      this.itemEditando = item || null;
      if (item) {
        this.form = {
          nome: item.nome,
          data: String(item.data).split("T")[0],
          tipo: item.tipo,
          uf: item.uf || "",
        };
      } else {
        this.form = { nome: "", data: "", tipo: "nacional", uf: "" };
      }
      this.dialog = true;
      if (this.$refs.formRef) this.$refs.formRef.resetValidation();
    },
    fecharFormulario() {
      this.dialog = false;
      this.modoEdicao = false;
      this.itemEditando = null;
      if (this.$refs.formRef) this.$refs.formRef.resetValidation();
    },
    async salvar() {
      if (!this.$refs.formRef.validate()) return;
      try {
        this.salvando = true;
        if (this.modoEdicao) {
          await this.$services.colaboradorPontosService.atualizarFeriado(
            this.itemEditando.id,
            this.form
          );
          this.$toast.success("Feriado atualizado com sucesso!");
        } else {
          await this.$services.colaboradorPontosService.cadastrarFeriado(this.form);
          this.$toast.success("Feriado cadastrado com sucesso!");
        }
        const anoSalvo = parseInt(this.form.data.split("-")[0], 10);
        this.fecharFormulario();
        await this.carregar();
        this.anoSelecionado = anoSalvo;
      } catch (error) {
        this.$handleError(error);
      } finally {
        this.salvando = false;
      }
    },
    confirmarExclusao(feriado) {
      this.feriadoParaExcluir = feriado;
      this.dialogExclusao = true;
    },
    async excluir() {
      try {
        this.excluindo = true;
        await this.$services.colaboradorPontosService.excluirFeriado(this.feriadoParaExcluir.id);
        this.$toast.success("Feriado excluído com sucesso!");
        this.dialogExclusao = false;
        await this.carregar();
      } catch (error) {
        this.$handleError(error);
      } finally {
        this.excluindo = false;
      }
    },
    formatarData(data) {
      if (!data) return "—";
      const [ano, mes, dia] = String(data).split("T")[0].split("-");
      return `${dia}/${mes}/${ano}`;
    },
    corTipo(tipo) {
      return { nacional: "blue", estadual: "green", municipal: "orange" }[tipo] || "grey";
    },
    labelTipo(tipo) {
      return { nacional: "Nacional", estadual: "Estadual", municipal: "Municipal" }[tipo] || tipo;
    },
    onTipoChange(tipo) {
      if (tipo === "nacional") this.form.uf = "";
    },
    validarTexto(v) {
      if (!v) return true;
      if (/\p{Emoji_Presentation}/u.test(v)) return "Emojis não são permitidos";
      if (/[<>{}[\]\\|^~`]/u.test(v)) return "Caracteres especiais não são permitidos";
      return true;
    },
    async abrirImportacao() {
      this.dialogImportacao = true;
      this.previewItens = [];
      this.importacaoTipo = "municipal";
      this.importacaoUf = "";
      this.carregandoPreview = true;
      try {
        const itens =
          await this.$services.colaboradorPontosService.previewImportacaoCalendarioLetivo();
        this.previewItens = itens.map((item) => ({ ...item, selecionado: false }));
      } catch (error) {
        this.$handleError(error);
        this.dialogImportacao = false;
      } finally {
        this.carregandoPreview = false;
      }
    },
    fecharImportacao() {
      this.dialogImportacao = false;
      this.previewItens = [];
    },
    toggleItemPreview(idx) {
      this.previewItens = this.previewItens.map((item, i) =>
        i === idx ? { ...item, selecionado: !item.selecionado } : item
      );
    },
    selecionarTodosItens() {
      const novoEstado = !this.todosSelecionados;
      this.previewItens = this.previewItens.map((item) => ({ ...item, selecionado: novoEstado }));
    },
    async confirmarImportacao() {
      if (this.importacaoTipo === "estadual" && !this.importacaoUf) {
        this.$toast.error("Selecione a UF para feriados estaduais.");
        return;
      }
      const itensSelecionados = this.previewItens.filter((i) => i.selecionado);
      if (itensSelecionados.length === 0) return;
      try {
        this.importando = true;
        const resultado = await this.$services.colaboradorPontosService.importarDoCalendarioLetivo({
          tipo: this.importacaoTipo,
          uf: this.importacaoTipo === "estadual" ? this.importacaoUf : null,
          itens: itensSelecionados.map((i) => ({ nome: i.nome, data: i.data })),
        });
        const total = resultado.importados;
        const msg =
          total === 1
            ? "1 feriado importado com sucesso!"
            : `${total} feriados importados com sucesso!`;
        this.$toast.success(msg);
        this.fecharImportacao();
        await this.carregar();
      } catch (error) {
        this.$handleError(error);
      } finally {
        this.importando = false;
      }
    },
  },
};
</script>
